import { UnstyledButtonType } from '@components/SearchBars/SearchFigma/types';
import { UnstyledButton } from '@mantine/core';
import styled from 'styled-components';

export const StyledButton: UnstyledButtonType = styled(UnstyledButton)`
  && {
    padding: 4px 12px;
    border-radius: 15px;
  }
  display: flex;
  column-gap: 10px;

  align-items: center;

  &.deleted {
    background-color: #ffe2e2;
  }

  :disabled {
    cursor: unset;
  }
`;
